import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/login/data-access/auth.service';
import { Router } from '@angular/router';
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import {Message} from "../../../admin/feature/system-management/announcement-list/announcement-list.component";
import {SystemManagementService} from "../../../admin/data-access/system-management.service";

@Component({
    selector: 'app-instructor-dashboard',
    templateUrl: './instructorDashboard.component.html',
    styleUrls: ['instructorDashboard.component.css'],
    standalone: false
})
export class InstructorDashboardComponent implements OnInit, OnDestroy {
  headerDivStyle = `font-size: 1.875rem; line-height: 2.25rem; color: ${localStorage.getItem('primaryColor')}; display: flex; align-items: center;`
  constructor(private router: Router) {}
  authService = inject(AuthService);

  firstName: string = '';
  lastName: string = '';
  isLoading: boolean = true;
  instructorMessages: Message[] = []
  instructorMessageIter = 0
  systemService = inject(SystemManagementService)
  messageBoxStyle = `background: linear-gradient(to left, transparent 10%, ${localStorage.getItem('primaryColor')}); border-radius: 8px; color: white; margin-top: 20px; margin-left: 20px;`
  showAllUsers = false
  roleCreate = false
  examCreate = false

  // Turn into a signal when angular updates and they are available
  userSub: Subscription = this.authService.user$.subscribe((user) => {
    if (user) {
      this.firstName = user.given_name;
      this.lastName = user.family_name;
      this.isLoading = false;
    }
  });

  ngOnInit(): void {
    this.systemService.listAnnouncements('instructor').subscribe((response) => {
      if(response.success) {
        this.instructorMessages = []
        for(let message of response.result) {
          if(message.dashboard === 'instructor' || message.dashboard === 'universal') {
            this.instructorMessages.push(message)
          }
        }
      } else {
        this.instructorMessages = []
      }
    })
  }

  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    if(user.result.some(el => el.ui === 'UserManage')) {
      this.showAllUsers = true
    }
    if(user.result.some(el => el.ui === 'UserRoleManage') || user.result.some(el => el.ui === 'RoleCreate')) {
      this.roleCreate = true
    }
    if(user.result.some(el => el.ui === 'ExamCreate')) {
      this.examCreate = true
    }
  })

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
    this.userPermissionSub.unsubscribe();
  }

  createExamClick() {
    this.router.navigate(['dashboard/exam/create'])
  }

  incrementMessages() {
    if(this.instructorMessageIter < this.instructorMessages.length)
      this.instructorMessageIter++
  }

  decrementMessages() {
    if(this.instructorMessageIter > 0)
      this.instructorMessageIter--
  }

  allUsersClick() {
    this.router.navigate(['dashboard/UserManagement/AllUsers'])
  }

  userRolesClick() {
    this.router.navigate(['dashboard/UserManagement/UserRoles'])
  }

  addNewUser() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/AddNewUser'])
  }

  importUsers() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/ImportUsers'])
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
}
